import { PropertyFilesLibrary, OverflowContent } from 'components';

const PropertiesFilesList = ({ propertyId }) => (
  <OverflowContent>
    <PropertyFilesLibrary uploadButtonPosition='top' propertyId={propertyId} />
  </OverflowContent>
);

export default PropertiesFilesList;